import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Table from "../shared/table/Table"; // Kendi tablo bileşeniniz
import { FiEdit3, FiTrash2, FiPlus } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";


const CategoryTable = () => {
  const { slug } = useParams(); 
  const [categoryList, setCategoryList] = useState([]);

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  // Kategori verilerini çek
  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("admin_token");

      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/category/slug/${slug}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setCategoryList(resp.data);
    } catch (error) {
      console.error("Kategori verileri alınamadı:", error);
      toast.error("Kategori listesi alınamadı!");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [slug]);

  const handleDelete = (id) => {
    confirmAlert({
      title: getText("CATEGORY_DELETE_CONFIRM_TITLE", "Kategoriyi Sil"),
      message: getText("CATEGORY_DELETE_CONFIRM", "Bu kategoriyi silmek istediğinize emin misiniz?"),
      buttons: [
        {
          label: getText("YES_DELETE", "Evet, Sil"),
          onClick: async () => {
            try {
              const token = localStorage.getItem("admin_token");
              await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/category/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              toast.success(getText("CATEGORY_DELETED", "Kategori silindi!"));
              fetchCategories();
            } catch (err) {
              console.error("Silme hatası:", err);
              const message = err.response?.data?.error || getText("CATEGORY_DELETE_ERROR", "Kategori silinemedi!");
              toast.error(message);
            }
          },
        },
        {
          label: getText("CANCEL", "İptal"),
          onClick: () => toast.info(getText("DELETE_CANCELLED", "Silme işlemi iptal edildi.")),
        },
      ],
    });
  };
  
  

  // Tablonun kolonları
  const columns = useMemo(() => {
    return [
      {
        accessorKey: "id",
        header: getText("TABLE_ID_LABEL"),
        meta: { headerClassName: "text-start", className: "text-start" },
        size: 60,
      },
      {
        accessorKey: "picture",
        header: getText("IMAGE"),
        meta: { headerClassName: "text-start", className: "text-start" },
        size: 80,
        cell: (info) => {
          const picValue = info.getValue();
          if (!picValue) return "-";

          return (
            <img
              src={`/${picValue}`} 
              alt="Kategori Görseli"
              style={{ width: 50, height: 50, objectFit: "cover", borderRadius: "4px" }}
            />
          );
        },
      },
      {
        accessorKey: "name",
        header: getText("CATEGORY_NAME"),
        meta: { headerClassName: "text-start", className: 'text-start title-column' },
        cell: (info) => {
          const val = info.getValue();
          return val || "-";
        },
      },

      {
        accessorKey: "created_at",
        header: getText("CREATED_AT"),
        meta: { headerClassName: "text-end", className: 'text-end date-column' },
        size: 130,
        cell: (info) => {
          const rawDate = info.getValue();
        const formattedDate = new Date(rawDate).toLocaleDateString('en-GB');
        return (
          <div style={{ textAlign: 'end', width: '125px' }}>
            {formattedDate}
          </div>
        );
        },
      },
      {
        accessorKey: "actions",
        header: getText("TABLE_ACTIONS_LABEL"),
        enableSorting: false,
        meta: { headerClassName: "text-end", className: "text-end" },
        size: 120,
        cell: (info) => {
          const rowData = info.row.original;
          return (
            <div className="hstack gap-2 justify-content-end">
              <Link
                to={`/modules/${slug}/category/edit/${rowData.id}`}
                className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
                title={getText("EDIT")}
              >
                <FiEdit3 />
              </Link>
              {rowData.hasDependencies ? (
                <button
                  className="avatar-text avatar-md text-secondary bg-soft-secondary border-soft-secondary"
                  title={getText("CANNOT_DELETE_HAS_DEPENDENCIES", "Bağlı alt kategoriler veya veriler var, önce onları silin.")}
                  disabled
                >
                  <FiTrash2 />
                </button>
              ) : (
                <button
                  className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
                  title={getText("DELETE", "Sil")}
                  onClick={() => handleDelete(rowData.id)}
                >
                  <FiTrash2 />
                </button>
              )}

            </div>
          );
        },
      },
    ];
  }, [slug, translations]);


  return (
    <div className="table-responsive">
      <ToastContainer />
      <Table data={categoryList} columns={columns} />
    </div>
  );
};

export default CategoryTable;
